
import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-navy via-charcoal to-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Get Started?
        </h2>
        <p className="text-xl text-gray-300 mb-12">
          Choose your funding path
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Business Funding Card */}
          <div className="bg-white rounded-xl p-10 text-left hover:shadow-2xl transition-all">
            <div className="w-14 h-14 bg-navy rounded-full flex items-center justify-center mb-6">
              <i className="ri-building-line text-2xl text-white"></i>
            </div>

            <h3 className="text-2xl font-semibold text-navy mb-4">
              Business Funding
            </h3>

            <p className="text-sm text-gray-600 leading-relaxed mb-8">
              Get positioned for business credit cards, lines of credit, term loans, and equipment financing. Build fundable business credit infrastructure.
            </p>

            <Link
              to="/apply"
              className="block w-full bg-navy text-white text-center py-4 rounded-lg font-medium hover:bg-navy-light transition-colors whitespace-nowrap cursor-pointer"
            >
              Apply for Business Funding
            </Link>
          </div>

          {/* Personal Funding Card */}
          <div className="bg-white rounded-xl p-10 text-left hover:shadow-2xl transition-all">
            <div className="w-14 h-14 bg-navy rounded-full flex items-center justify-center mb-6">
              <i className="ri-user-line text-2xl text-white"></i>
            </div>

            <h3 className="text-2xl font-semibold text-navy mb-4">
              Personal Funding
            </h3>

            <p className="text-sm text-gray-600 leading-relaxed mb-8">
              Optimize your personal credit profile and get positioned for personal loans, 0% credit cards, and strategic funding opportunities.
            </p>

            <Link
              to="/apply"
              className="block w-full bg-navy text-white text-center py-4 rounded-lg font-medium hover:bg-navy-light transition-colors whitespace-nowrap cursor-pointer"
            >
              Apply for Personal Funding
            </Link>
          </div>

          {/* Buy Tradelines Card */}
          <div className="bg-white rounded-xl p-10 text-left hover:shadow-2xl transition-all">
            <div className="w-14 h-14 bg-navy rounded-full flex items-center justify-center mb-6">
              <i className="ri-line-chart-line text-2xl text-white"></i>
            </div>

            <h3 className="text-2xl font-semibold text-navy mb-4">
              Buy Tradelines
            </h3>

            <p className="text-sm text-gray-600 leading-relaxed mb-8">
              Browse and purchase available seasoned tradelines to strengthen your credit profile and improve your funding eligibility.
            </p>

            <Link
              to="/buy-tradelines"
              className="block w-full bg-navy text-white text-center py-4 rounded-lg font-medium hover:bg-navy-light transition-colors whitespace-nowrap cursor-pointer"
            >
              View Tradelines
            </Link>
          </div>
        </div>

        <div className="mt-12">
          <p className="text-gray-400 text-sm">
            Not sure which path is right for you?{' '}
            <Link
              to="/apply"
              className="text-white underline hover:text-gray-200 cursor-pointer"
            >
              Start with a pre-qualification
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
